<template>
  <div id="errorModal" class="errorModal" >
    <b-modal v-model="errorModalShow" title="Error" @ok="closeModal" @cancel="closeModal">
      <span>{{text}}</span>
    </b-modal>
  </div>
</template>
<script>

export default {
  name: 'ErrorModal',
  props: ['text', 'errorModalShow'],
  methods: {
    closeModal: function (evt) {
      this.$emit('closeModal', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ErrorModal.vue